import React from 'react';

const ServicePackageDetails = ({ service, packageData }) => {
  if (!service && !packageData) return null;

  return (
    <section className="rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 shadow-sm">
      <div className="mb-5">
        <h2 className="text-base font-bold text-gray-900">Service & package</h2>
        <p className="text-sm text-gray-500 mt-0.5">What the client booked</p>
      </div>

      {service ? (
        <div className={packageData ? 'mb-5 pb-5 border-b border-gray-100' : ''}>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-1">
            Service
          </p>
          <p className="text-sm sm:text-base font-semibold text-gray-900 break-words">
            {service.service_name}
          </p>
          {service.service_category?.category_name ? (
            <p className="text-sm text-gray-500 mt-1">{service.service_category.category_name}</p>
          ) : null}
        </div>
      ) : null}

      {packageData ? (
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-1">
            Package
          </p>
          <p className="text-sm sm:text-base font-semibold text-gray-900 break-words">
            {packageData.package_name}
          </p>
          {packageData.description ? (
            <p className="mt-2 text-sm text-gray-600 leading-relaxed break-words">
              {packageData.description}
            </p>
          ) : null}
        </div>
      ) : null}
    </section>
  );
};

export default ServicePackageDetails;
